import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1, 5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "This simulation illustrate aliasing. A pure signal at f = 440 Hz (continuous red line) is sampled at frequency F<sub>s</sub>. The sampled signal is represented by the blue dots. When the sampling frequency is higher than 880 Hz, the signal is well correctly represented and when its lower we can hear the effect of aliasing. In that case,  the sound is associated to the blue signal whose points coincide with the one of the red signal at sampling times.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "iframe",
                  options: {
                    src: `${config.IFRAMES_REACT_URL}/0305b/`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
